import React from "react";
import './ImageContent.css' 


export default props => (
    <img src={props.block.text} className="image-content"/>
  );